export const DAYS = 1000 * 60 * 60 * 24;
export const TOKEN_TIMEOUT = 1000 * 60 * 15;

export const FULLNAME_PATTERN = /^\s?([a-zA-Z'-]+[,.]?[ ]+)+[a-zA-Z'-]{1,}\s?$/i;
export const PHONE_PATTERN = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
export const PATHNAME = /#(.*?)(?:\?|$)/g; // e
